<h1 style="text-align: center;" mat-dialog-title>Creación de Usuario</h1>

<div mat-dialog-content>

  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center" style="margin-bottom: 10px;">

    <button mat-raised-button [disabled]="!buttonEnabled" class="zb-button" style="background-color: rgb(82, 155, 219)">
      <mat-checkbox [(ngModel)]="esUsuarioAdmin" (change)="esUsuarioPropietario=false" color="primary">Soy Administrador</mat-checkbox>
    </button>
    <button mat-raised-button [disabled]="!buttonEnabled" class="zb-button" style="background-color: rgb(98, 207, 84)">
      <mat-checkbox [(ngModel)]="esUsuarioPropietario" (change)="esUsuarioAdmin=false" color="primary">Soy Propietario/Inquilino</mat-checkbox>
    </button>

  </div>

  <ng-container *ngIf="esUsuarioAdmin">

    <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

    <form [formGroup]="formAdminGroup">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
          <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Por favor completa los datos de tu administración</mat-label>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Razón Social*</mat-label>
            <input matInput formControlName="RazonSocial" type="text" (keyup.enter)="onGuardar()" maxlength="150">
            <mat-error *ngIf="!formAdminGroup.controls['RazonSocial'].valid && formAdminGroup.controls['RazonSocial'].touched">
              {{ getAdminErrorRazonSocial() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>CUIT</mat-label>
            <input matInput formControlName="Cuit" type="number" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>

      </div>

      <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
          <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Por favor ahora completa los datos para contactarte</mat-label>
        </div>

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nombre y Apellido*</mat-label>
            <input matInput formControlName="NombreContacto" type="text" (keyup.enter)="onGuardar()" maxlength="150">
            <mat-error *ngIf="!formAdminGroup.controls['NombreContacto'].valid && formAdminGroup.controls['NombreContacto'].touched">
              {{ getAdminErrorNombreContacto() }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Mail*</mat-label>
            <input matInput formControlName="Mail" type="email" (keyup.enter)="onGuardar()" maxlength="255">
          </mat-form-field>
          <mat-error *ngIf="!formAdminGroup.controls['Mail'].valid && formAdminGroup.controls['Mail'].touched">
            {{ getAdminErrorMail() }}
          </mat-error>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Móvil</mat-label>
            <input matInput formControlName="Movil" type="text" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>
        
      </div>

      <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
          <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Por último, contanos sobre los consorcios que queres que te ayudemos a gestionar</mat-label>
        </div>

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Cantidad de Consorcios*</mat-label>
            <input matInput formControlName="CantidadConsorcios" type="number" (keyup.enter)="onGuardar()">
            <mat-error *ngIf="!formAdminGroup.controls['CantidadConsorcios'].valid && formAdminGroup.controls['CantidadConsorcios'].touched">
              {{ getAdminErrorCantidadConsorcios() }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

    </form>

    <div fxLayout="row stretch" fxLayout.xs="column">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
        <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">¿Queres detallarnos los nombres de las comunidades (edificios, barrios, etc.) que forman parte de tu consorcio?</mat-label>
      </div>

      <div fxFlex=75 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Agrega una comunidad</mat-label>
              <input matInput [(ngModel)]="newConsorcio" [ngModelOptions]="{standalone: true}" (keyup.enter)="onConsorcioAdd()">
          </mat-form-field>
      </div>
      <div fxFlex=25 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
          <div fxLayout="row stretch" fxLayout.xs="column">
              <button mat-raised-button (click)="onConsorcioAdd()" [disabled]="!buttonEnabled" color="primary" class="zb-button">
                <i class="fa fa-plus fa-1x" style="margin-right: 3px;"></i>Agregar
              </button>
          </div>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
        <ng-container *ngFor="let c of consorcios">
          <mat-label style="background-color: lightgray; padding: 7px; margin: 8px 5px; border-radius: 10px;">
            {{c}}
            <button mat-icon-button style="margin-left: 3px;" (click)="onConsorcioDelete(c)" title="Eliminar consorcio">
              <i class="fa fa-trash fa-1x"></i>
            </button>
          </mat-label>
        </ng-container>
      </div>

    </div>

  </ng-container>

  <ng-container *ngIf="esUsuarioPropietario">

    <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

    <form [formGroup]="formUserGroup">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
          <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Por favor completa tus datos personales</mat-label>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nombre*</mat-label>
            <input matInput formControlName="Nombre" type="text" (keyup.enter)="onGuardar()" maxlength="150">
            <mat-error *ngIf="!formUserGroup.controls['Nombre'].valid && formUserGroup.controls['Nombre'].touched">
              {{ getErrorNombre() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Apellido</mat-label>
            <input matInput formControlName="Apellido" type="text" (keyup.enter)="onGuardar()" maxlength="150">
            <mat-error *ngIf="!formUserGroup.controls['Apellido'].valid && formUserGroup.controls['Apellido'].touched">
              {{ getErrorApellido() }}
            </mat-error>
          </mat-form-field>
        </div>
  
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nro. Documento</mat-label>
            <input matInput formControlName="NroDocumento" type="text" (keyup.enter)="onGuardar()" maxlength="100">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Móvil</mat-label>
            <input matInput formControlName="Movil" type="text" (keyup.enter)="onGuardar()" maxlength="100">
          </mat-form-field>
        </div>
      </div>
  
      <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
          <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Ahora por favor completa los datos del usuario que queres crear</mat-label>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Mail*</mat-label>
            <input matInput formControlName="Mail" type="email" (keyup.enter)="onGuardar()" maxlength="255">
            <mat-error *ngIf="!formUserGroup.controls['Mail'].valid && formUserGroup.controls['Mail'].touched">
              {{ getErrorMail() }} 
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nombre de Usuario*</mat-label>
            <input matInput formControlName="Login" type="text" (keyup.enter)="onGuardar()" maxlength="100">
            <mat-error *ngIf="!formUserGroup.controls['Login'].valid && formUserGroup.controls['Login'].touched">
              {{ getErrorLogin() }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Clave*</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="Clave" (keyup.enter)="onGuardar()">
            <mat-error *ngIf="!formUserGroup.controls['Clave'].valid && formUserGroup.controls['Clave'].touched">
              {{ getErrorClave() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Confirma tu Clave*</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="ConfirmClave" (keyup.enter)="onGuardar()">
            <mat-error *ngIf="!formUserGroup.controls['ConfirmClave'].valid && formUserGroup.controls['ConfirmClave'].touched">
              {{ getErrorConfirmClave() }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

    </form>

  </ng-container>

</div>

<div mat-dialog-actions align="center">
  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
    <button mat-raised-button color="primary" (click)="onGuardar()" *ngIf="esUsuarioAdmin || esUsuarioPropietario" [disabled]="!buttonEnabled" class="zb-button"><mat-icon>input</mat-icon> {{buttonEnabled ? 'Crear' : 'Creando...'}}</button>
    <button mat-raised-button color="warn" (click)="onCancelar()" [disabled]="!buttonEnabled" class="zb-button"><mat-icon>cancel</mat-icon> Cancelar</button>  
  </div>
</div>